<script lang="ts">
    import { getContext } from "svelte";
    import Page from "../components/Page.svelte";
    import { useLocation } from "../components/router/context";
    import Footer from "../components/Footer.svelte";
    
    const { navigate } = useLocation();

    const gigyaContext: any = getContext("gigya");

    $effect(() => {
        if (gigyaContext.ready) {
            gigya.accounts.showScreenSet({
                screenSet: 'Default-GuestInteraction',
                containerID: 'gigya-screen',
                authMode: 'popup'
            });
        }
    });

</script>
{#snippet footerSlot()}
    <Footer />
{/snippet}
<Page footer={footerSlot}>
    <article class="container m-auto flex flex-col items-center justify-center">
        <img src="/img/league-logo.png" alt="league logo" class="h-40 object-contain mb-8" />
        <div id="gigya-screen" class="w-full"></div>
    </article>
</Page>

<style>
</style>